import { Component, Input } from '@angular/core';
import { isColorDarkOrLight, isNotNuloOuUndefined } from '@utils';
import { Posto } from '@home/submodulos/dados-meteorologicos/interfaces/boletim';

export type PostoPopupBoletim = Posto & {
	siglaTipoEstacao?: string;
	origemValor?: boolean;
};

@Component({
	selector: 'seira-popup-boletim-diario-mapa',
	templateUrl: './popup-boletim-diario-mapa.component.html',
	styleUrls: ['./popup-boletim-diario-mapa.component.scss'],
})
export class PopupBoletimDiarioMapaComponent {
	@Input() headerColor!: string;
	@Input() nome!: string;
	@Input() precipitacaoAcumulada?: string | null = null;
	@Input() informacaoExtra?: string | null = null;
	descricaoPostoValor = '';

	@Input() set postos(valor: PostoPopupBoletim[]) {
		this.listaPostos = valor ?? [];
		const postoOrigem = this.listaPostos.find(posto => posto.origemValor);
		this.descricaoPostoValor = postoOrigem
			? `${postoOrigem.posto} - ${postoOrigem.siglaTipoEstacao}`
			: '';
	}

	get postos(): PostoPopupBoletim[] {
		return this.listaPostos;
	}

	private listaPostos: PostoPopupBoletim[] = [];
	protected readonly isNotNuloOuUndefined = isNotNuloOuUndefined;

	handleTextColorBasedOnBackgroundColor(
		backgroundColor: string
	): string | undefined {
		if (isColorDarkOrLight(backgroundColor) == 'escura') {
			return 'text-white';
		}
		return;
	}
}
